import type { DesignModule } from '../types'
import { SignalAdminApiTokens } from './components/admin-api-tokens-screen'
import { SignalAdminCredentials } from './components/admin-credentials-screen'
import { SignalAdminLocations } from './components/admin-locations-screen'
import { SignalAdminPermissions } from './components/admin-permissions-screen'
import { SignalAdminRoles } from './components/admin-roles-screen'
import { SignalAdminTenantDetail, SignalAdminTenants } from './components/admin-tenants-screen'
import { SignalAdminUsers } from './components/admin-users-screen'
import { SignalClients } from './components/clients-screen'
import { SignalDashboard } from './components/dashboard-screen'
import { SignalLocationDetail } from './components/location-detail-screen'
import { SignalLocations } from './components/locations-screen'
import { SignalManagedDevices } from './components/managed-devices-screen'
import { SignalNetwork } from './components/network-screen'
import { SignalPosTerminals } from './components/pos-terminals-screen'
import { SignalReservations } from './components/reservations-screen'
import { SignalShell } from './components/shell'
import { SignalSwitchPorts } from './components/switch-ports-screen'
import { SignalWanSettings } from './components/wan-settings-screen'

export const v2: DesignModule = {
  name: 'Signal',
  description:
    'Dense pro-tool: Geist + Geist Mono, hairlines, 28px rows, dark-mode hero, keyboard-first, indigo accent.',
  Shell: SignalShell,
  screens: {
    dashboard: SignalDashboard,
    locations: SignalLocations,
    locationDetail: SignalLocationDetail,
    network: SignalNetwork,
    wanSettings: SignalWanSettings,
    managedDevices: SignalManagedDevices,
    reservations: SignalReservations,
    switchPorts: SignalSwitchPorts,
    clients: SignalClients,
    posTerminals: SignalPosTerminals,
    adminUsers: SignalAdminUsers,
    adminRoles: SignalAdminRoles,
    adminPermissions: SignalAdminPermissions,
    adminTenants: SignalAdminTenants,
    adminTenantDetail: SignalAdminTenantDetail,
    adminApiTokens: SignalAdminApiTokens,
    adminCredentials: SignalAdminCredentials,
    adminLocations: SignalAdminLocations,
  },
}
